export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40a66330ddeaddba062c9a0e3c52c69347519cda69&name=revalidateCommunity!'